// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from 'D:/apps/mys/pta-admin/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import CrownOutlined from 'D:/apps/mys/pta-admin/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/CrownOutlined';
import SettingOutlined from 'D:/apps/mys/pta-admin/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SettingOutlined';
import FileDoneOutlined from 'D:/apps/mys/pta-admin/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/FileDoneOutlined';
import BarChartOutlined from 'D:/apps/mys/pta-admin/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/BarChartOutlined';
export default { SmileOutlined, CrownOutlined, SettingOutlined, FileDoneOutlined, BarChartOutlined };
